import { IScheduleContext } from "Interfaces/Providers/Schedule";
import { ScheduleContext } from "providers/Schedule/ScheduleProvider";
import { useContext } from "react";

export default function useSchedule(): IScheduleContext {
  const context = useContext(ScheduleContext);

  return context;
}
